export default __webpack_public_path__ + "static/media/triiboLg.c910a6da.png";